var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGmailLogo = function SvgGmailLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "52 42 88 66"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc04",
    d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M72 74V48l24 18 24-18v26L96 92"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c5221f",
    d: "M52 51v8l20 15V48l-5.6-4.2C60.46 39.35 52 43.58 52 51"
  })));
};
export default SvgGmailLogo;